import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  icon: {
    fontSize: "130%",
    margin: theme.spacing(0, 3),
  },
  iconContainer: {
    display: "flex",
    alignItems: "flex-end",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.secondary.tint60,
    },
    height: "100%",
  },
  popOver: {
    maxWidth: [theme.spacing(90), "!important"],
    minHeight: [theme.spacing(42), "!important"],
  },

  card: {
    height: theme.spacing(24),
    width: theme.spacing(24),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    fontSize: "160%",
    cursor: "pointer",
  },
  popOver: {
    maxWidth: theme.spacing(150),
    minHeight: theme.spacing(51),
    minWidth: theme.spacing(61),
    padding: theme.spacing(10),
    borderRadius: theme.spacing(3),
    backgroundColor: theme.palette.secondary.tint90,
    color: theme.palette.secondary.tint15,
    direction: "ltr",
  },
  popOverContainer: {
    marginTop: theme.spacing(8),
    marginRight: [-theme.spacing(12), "!important"],
  },
  closeIcon: {
    backgroundColor: theme.palette.red.main,
    borderRadius: "50%",
  },
  popOverText: {
    color: theme.palette.secondary.tint15,
  },
}));
